import PropTypes from "prop-types";
import React from "react";
import _ from "underscore";
import { outcomePropType } from "../../lib/dataShapes";
import ContentBox from "../common/ContentBox";
import ContOutcomeTableRow from "./ContOutcomeTableRow";
import DichOutcomeTableRow from "./DichOutcomeTableRow";
import NarrativeOutcomeTableRow from "./NarrativeOutcomeTableRow";
import contentBoxStyles from "../../styles/contentBox.module.scss";
import "../../styles/outcomeTable.scss";
import styles from "../../styles/outcomeTable.module.scss";

const OutcomesTable = ({
  comparison,
  explanations,
  intervention,
  outcomes
}) => {
  return (
    <ContentBox className={contentBoxStyles.outcomeTableContentBox}>
      <div className={styles.header}>
        <div className={styles.outcomesTitle}>Outcomes</div>
        <div className={styles.comparison}>
          <h2 className={styles.outcomesTableHeader}>{comparison}</h2>
        </div>
        <div className={styles.intervention}>
          <h2 className={styles.outcomesTableHeader}>{intervention}</h2>
        </div>
        <div className={styles.certainty}>Certainty of the evidence</div>
      </div>
      <div className={styles.outcomes}>
        {_.map(outcomes, outcome => (
          <div key={outcome._id}>
            {outcome.type === "cont" && (
              <ContOutcomeTableRow
                comparison={comparison}
                intervention={intervention}
                outcome={outcome}
              />
            )}
            {outcome.type === "narrative" && (
              <NarrativeOutcomeTableRow outcome={outcome} />
            )}
            {outcome.type === "dich" && (
              <DichOutcomeTableRow
                comparison={comparison}
                intervention={intervention}
                outcome={outcome}
              />
            )}
          </div>
        ))}
      </div>
      <div className={styles.explanations}>
        {_(explanations).map((explanation, index) => (
          <div key={index}>
            {explanation.key}
            {explanation.value}
          </div>
        ))}
      </div>
    </ContentBox>
  );
};

OutcomesTable.propTypes = {
  comparison: PropTypes.string.isRequired,
  explanations: PropTypes.array,
  intervention: PropTypes.string.isRequired,
  outcomes: PropTypes.arrayOf(PropTypes.shape(outcomePropType)).isRequired
};

OutcomesTable.defaultProps = {
  explanations: []
};

export default OutcomesTable;
